export class FilterUsers {
  firstName?: string[];
  lastName?: string[];
  email?: string[];
  roles?: string[];
  hasBusinessIdentifier?: string;
}